import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ngx-error-message',
    templateUrl: './error-message.component.html',
    styleUrls: ['./error-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ErrorMessageComponent {}
